module.exports = __webpack_public_path__ + "img/3_ru.e8522016.jpg";